module.exports = __webpack_public_path__ + "img/W-8.29160617.jpg";